import React from 'react';
import '../intac_kl_page/intac_2026_page1.css';
import infoIcon from "../../parm_assets/tree_icons.png";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'

import IntacLogo00 from "../../parm_assets/intac_kl/INTAC_LOGO_00.png";
import IntacLogo04 from "../../parm_assets/intac_kl/INTAC Logo-04.png";
import register_form_qr from "../../parm_assets/intac_kl/register_form_intac.jpeg";
import hotel from "../../parm_assets/intac_kl/hotel.webp";
import { Map, Marker } from 'pigeon-maps';
import waze from "../../parm_assets/intac_kl/waze.png";
import googlemaps from "../../parm_assets/intac_kl/google-maps.png";

const intacBkg = "https://ik.imagekit.io/axiomhives/parm_assets/intac_kl/INTAC_BANNER_NEW.png?updatedAt=1769929468176";
const IntacPoster = "https://ik.imagekit.io/axiomhives/parm_assets/intac_kl/INTAC%202026%20poster-for%20puteri-3.png";
const IntacLogo = "https://ik.imagekit.io/axiomhives/parm_assets/intac_kl/INTAC_LOGO_00.png?updatedAt=1769929447140";
const SponsorImg = "https://ik.imagekit.io/axiomhives/parm_assets/intac_kl/PNG/Artboard%207-crop.png";
const scanqr = "https://ik.imagekit.io/axiomhives/parm_assets/intac_kl/parm%20QR.png?updatedAt=1772079341631";

const fees = [
    { label: "Early Birds (Before 31st May 2026)", sub: "(Before 31st May 2026)", price: "RM1,275" },
    { label: "PArM Member", price: "RM1,400" },
    { label: "Non-PArM Members", price: "RM1,500" },
    { label: "Students", price: "RM1,200" },
    { label: "International", sub: "(USD 350)", price: "USD450" },
    // { label: "Booth", price: "RM3,000" },
  ];

  const fees2 = [
    // { label: "Early Birds", sub: "(Before 31st May 2026)", price: "RM1,275" },
    { label: "PArM Member", price: "RM1000" },
    { label: "Non-PArM Members", price: "RM1,500" },
    { label: "Students", price: "RM900" },
    { label: "International", sub: "(USD 350)", price: "USD500" },
    // { label: "Booth", price: "RM3,000" },
  ];

  const logos = [1, 2, 3, 4];

  const details = [
    {
      label: "The Light Hotel",
      content: "Lebuh Tenggiri 2, 13700 Seberang Jaya, Pulau Pinang",
    },
    {
      label: "The Light Hotel Contact No",
      content: "04-382 1111",
      isLink: false, // You can wrap this in an <a> tag if needed
    },
    {
      label: "The Light Hotel",
      content: "https://www.thelighthotelpg.com/",
      isUrl: true,
    }
  ];

  const position = [5.3941, 100.398];

  const LogoGrid = () => (
    <div className="logo-grid-2026Page1-section3">
      {logos.map((i) => (
        <div key={i} className="logo-item-2026Page1-section3">
          <img 
            src={IntacLogo00} 
            alt="INTAC 2026 Seberang Perai Logo" 
          />
        </div>
      ))}
    </div>
  );

const Intac2026Page1Section = () => {
  return (
    <div className="page-container">

   <section className="intackl-hero-section">
        <div className="intac-hero-content" style={{ backgroundImage: `url(${intacBkg})` }}>
        
        </div>
      </section>

    <section className="intac-container-2026Page1">
      {/* Left Column: Exploring INTAC Programme */}
      <div className="intac-column-2026Page1">
        <div className="header-meta-2026Page1">
          <span className="small-label-intac2026">
                          <img src={infoIcon} alt="icon" className="tree-icon" />
                          INTAC SEBERANG PERAI</span>
        </div>
        <h2 className="main-title-2026Page1">Exploring INTAC Programme</h2>

        <div className="outer-image-card-intac2026">
        <div className="image-card-2026Page1 left-card-2026Page1">
          <Zoom>
          <img 
            src={IntacPoster} 
            alt="INTAC 2026 Poster - Advancing Arboriculture" 
          />
          </Zoom>
        </div>
        </div>
      </div>

      {/* Right Column: Sponsorship Package */}
      <div className="intac-column-2026Page1">
        <div className="header-meta-2026Page1">
          <span className="small-label-intac2026">
                          <img src={infoIcon} alt="icon" className="tree-icon" />
                          SPONSORSHIP</span>
        </div>
        <h2 className="main-title-2026Page1">Sponsorship Package</h2>
        
        <div className="content-text-2026Page1">
          
          <p>
            INTAC Seberang Perai 2026 has a selection of Sponsorship Packages available, 
            tailored to the conference return benefits depend on the amount of sponsorship commitment. 
            Each package offers an opportunity to benefit from an integrated marketing and 
            promotional campaign that positions your organization as a premier source for solutions and advice.
          </p>
        </div>

        <div className="image-card-2026Page1">
          <Zoom>
          <img 
            src={SponsorImg} 
            alt="INTAC 2026 Logo Background"
            className="sponsor-image"
          />
          </Zoom>
        </div>
        
        <div className="image-card-2026Page1 ">
          <img 
            src={IntacLogo} 
            alt="INTAC 2026 Logo Background"
            className='intac-logo-sponsor'
          />
        </div>
      </div>
    </section>

    <section className="intac-container-2026Page1-section2">
      {/* Left Column: Exploring INTAC Programme */}
      {/* <div className="intac-2026Page1-section2"> */}
        <div className="header-2026Page1-section2">
          <span className="small-label-intac2026">
                          <img src={infoIcon} alt="icon" className="tree-icon" />
                          FEE AND PAYMENT</span>
        </div>
        <h1 className="title-2026Page1-section2">Conference Fee & Payment</h1>
        <div className="overlap-container-2026Page1-section2">
        {/* Top Darker Section */}
        <div className="fee-card-2026Page1-section2 image-bg-top">
          <div className="fee-content-2026Page1-section2">
            <div className="fee-list-2026Page1-section2">
              {/* <h2 className="section-title-2026Page1-section2">Early Bird (Before 30 June 2026)</h2> */}
              {fees.map((f, i) => (
                <div key={i} className="fee-row-2026Page1-section2">
                  <div className="fee-info-2026Page1-section2">
                    <span className="fee-name-2026Page1-section2">{f.label}</span>
                    {/* {f.sub && <span className="fee-sub-2026Page1-section2">{f.sub}</span>} */}
                  </div>
                  <span className="fee-value-2026Page1-section2">{f.price}</span>
                </div>
              ))}
            </div>

            {/* <div className="fee-list-2026Page1-section2">
              <h2 className="section-title-2026Page1-section2">Normal (After 30 June 2026)</h2>
              {fees2.map((f, i) => (
                <div key={i} className="fee-row-2026Page1-section2">
                  <div className="fee-info-2026Page1-section2">
                    <span className="fee-name-2026Page1-section2">{f.label}</span>
                
                  </div>
                  <span className="fee-value-2026Page1-section2">{f.price}</span>
                </div>
              ))}
            </div> */}

            {/* <div className="payment-qr-side-2026Page1-section2">
              <h2 className="payment-title-2026Page1-section2">Payment</h2>
              <div className="outer-image-card-2026Page1-section2">
              <div className="qr-wrapper-2026Page1-section2">
                <img src="https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=Payment" alt="QR" />
              </div>
              </div>
            </div> */}
          </div>
        </div>

        {/* Bottom Lighter Section (The Overlap) */}
        <div className="bank-card-2026Page1-section2 image-bg-bottom">
          <div className="fee-content-2026Page1-section2">
             <div className="payment-qr-side-2026Page1-section2">
              <h2 className="payment-title-2026Page1-section2">Payment</h2>
              <div className="outer-image-card-2026Page1-section2">
              <div className="qr-wrapper-2026Page1-section2">
                <img src={scanqr} alt="QR" className='qrbank'/>
              </div>
              </div>
            </div>

          <div className="or-divider-2026Page1-section2">
            <h3 className="account-title-2026Page1-section2">Payment of registration fee should be banked in to RHB Islamic Bank before <strong>15 August 2026</strong>. 
            Kindly provide us with the remittance advice slip for our reference.</h3>
            <h3 className="payment-detail-title">Payment Details</h3>
          <div className="bank-info-2026Page1-section2">
            <p>Cross Cheque Payable To: <strong>PERSATUAN ARBORIST MALAYSIA</strong></p>
            <p>RHB Islamic Account: <strong>21245760009232</strong></p>
            <p>Bank Branch: <strong>BANDAR BARU BANGI</strong></p>
            <p>Swift Code: <strong>RHBAM YKL</strong></p>
          </div>
          </div>
         
          </div>
        </div>
      </div>
    </section>


    <div className="page-wrapper-2026Page1-section3">
      {/* Top Logo Row */}
      {/* <LogoGrid /> */}

      {/* Main Registration Card */}
      <section className="registration-card-2026Page1-section3">
        <div className="qr-wrapper-2026Page1-section3">
          <div className="qr-code-2026Page1-section3">
            <img 
              src={register_form_qr} 
              alt="Registration QR Code" 
            />
          </div>
        </div>

        <div className="content-wrapper-2026Page1-section3">
          {/* <span className="event-label-2026Page1-section3">EVENT REGISTRATION <span className="arrow">➤</span></span> */}
          <h2 className="registration-title-2026Page1-section3">Event Registration</h2>
        
          <p className="registration-text-2026Page1-section3">
            <a href="https://docs.google.com/forms/d/e/1FAIpQLSdDLus4wnC9FIyronAJGaXT00VhQh2g0vdsmbn1jNCYjNiEKg/viewform" className="registration-link-2026Page1-section3">Click Here : Registration INTAC Seberang Perai 2026 Online Form</a>
            {" "}or you can scan our QR code for the online registration.
          </p>

          <div className="closing-date-2026Page1-section3">
            {/* <span className="check-icon-2026Page1-section3">✓</span> */}
            Registration Closing Date : <strong> 15 August 2026</strong>
          </div>
        </div>
      </section>

      {/* Bottom Logo Row */}
      {/* <LogoGrid /> */}
    </div>

    
    <div className="venue-section-2026Page1-section4">
      <div className="venue-container-2026Page1-section4">
        {/* Left Column: Text Content */}
        <div className="venue-text-side-2026Page1-section4">
          <div className="venue-title-area-2026Page1-section4">
            <span className="venue-label-2026Page1-section4">
              <span className="small-label-intac2026">
                          <img src={infoIcon} alt="icon" className="tree-icon" />
                          VENUE</span>
            </span>
            <h1 className="venue-main-heading-2026Page1-section4">Venue Details</h1>
          </div>

          <div className="info-list-2026Page1-section4">
            <div className="info-item-2026Page1-section4">
              <h3>The Light Hotel</h3>
              <p>Lebuh Tenggiri 2, 13700 Seberang Jaya, Pulau Pinang</p>
            </div>
            
            <div className="info-item-2026Page1-section4">
              <h3>The Light Hotel Contact No</h3>
              <p><u>+604–382 1111</u></p>
            </div>

            <div className="info-item-2026Page1-section4">
              <h3>The Light Hotel</h3>
              <p>https://www.thelighthotelpg.com/</p>
            </div>
          </div>
        </div>

        {/* Right Column: Image and Badge */}
        <div className="venue-visual-side-2026Page1-section4">
          <div className="image-wrapper-2026Page1-section4">
            <div className="intac-badge-2026Page1-section4">
               <div className="badge-content-2026Page1-section4">
                  <span className="badge-logo-text-2026Page1-section4">
                    <img 
                      src={IntacLogo04} 
                      alt="The Light Hotel Building" 
                      className="intaclogo-img-2026Page1-section4"
                    />
                  </span>
                  {/* <span className="badge-sub-text-2026Page1-section4">SEBERANG PERAI</span> */}
               </div>
            </div>
            <img 
              src={hotel} 
              alt="The Light Hotel Building" 
              className="hotel-img-2026Page1-section4"
            />
          </div>
        </div>
      </div>
    </div>


     <div className="section-container-2026page1-section5">
      {/* Map Wrapper */}
      <div className="map-pill-container-2026page1-section5">
        <Map
          height={380}
          defaultCenter={position}
          defaultZoom={15}
          // Using a custom provider to get that clean teal/blue look
          // If you want standard OSM, just remove the provider prop
         provider={(x, y, z) => `https://tile.openstreetmap.org/${z}/${x}/${y}.png`}
        >
          <Marker width={50} anchor={position} color="#1a5f63" />
        </Map>
      </div>

      {/* Action Bar */}
      <div className="action-bar-container-2026page1-section5">
        <div className="action-bar-2026page1-section5">
          <span className="action-text-2026page1-section5">Click Here:</span>
          <div className="icon-group-2026page1-section5">
            <a
              href={"https://maps.app.goo.gl/PPn2ZySj1S6VQ9Ms7"}
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={googlemaps}
                alt="Google Maps"
                className="nav-icon-2026page1-section5"
              />
            </a>
            <a
              href={"https://waze.com/ul/hw0zqsw5f9"}
              target="_blank"
              rel="noreferrer"
            >
              <img src={waze} alt="Waze" className="nav-icon-2026page1-section5" />
            </a>
          </div>
        </div>
      </div>
    </div>

    </div>
  );
};

export default Intac2026Page1Section;